module.exports = __webpack_public_path__ + "static/img/tt-3.12d453d.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/tt-3.jpg
 ** module id = 590
 ** module chunks = 2
 **/